import React from "react";
import { Container, Typography } from "@material-ui/core";

import { AdminOrdersProvider } from "./AdminOrdersContext";
import { AdminOrdersTable } from "./AdminOrdersTable";

export const AdminOrdersView: React.FC = () => {
  return (
    <AdminOrdersProvider>
      <Container
        style={{
          minHeight: "75vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0",
        }}
      >
        {/* "lg" (1280px) instead of "md" (960px): this is the densest admin table,
            and the extra width is part of what lets every column fit on screen
            without a horizontal scrollbar. */}
        <Container maxWidth="lg" style={{ padding: "2rem 0" }}>
          <Typography
            variant="h3"
            style={{ fontSize: "1.4rem", marginBottom: "1rem" }}
          >
            Orders
          </Typography>
          <AdminOrdersTable />
        </Container>
      </Container>
    </AdminOrdersProvider>
  );
};
